export const UNSAVED_RUN_SCAN_RESULTS_KEY = 'black_peak_unsaved_run_scan_results';

export function loadUnsavedRunScanResults() {
  try {
    const storedResults = sessionStorage.getItem(UNSAVED_RUN_SCAN_RESULTS_KEY);
    if (!storedResults) return null;

    const results = JSON.parse(storedResults);
    if (!results || !Array.isArray(results.ranked_stocks)) {
      sessionStorage.removeItem(UNSAVED_RUN_SCAN_RESULTS_KEY);
      return null;
    }

    return results;
  } catch {
    sessionStorage.removeItem(UNSAVED_RUN_SCAN_RESULTS_KEY);
    return null;
  }
}

export function saveUnsavedRunScanResults(results) {
  sessionStorage.setItem(UNSAVED_RUN_SCAN_RESULTS_KEY, JSON.stringify(results));
}

export function clearUnsavedRunScanResults() {
  sessionStorage.removeItem(UNSAVED_RUN_SCAN_RESULTS_KEY);
}
